export const SHOW_ANNOTATION_DURATION = 5.0

export const AnnotationActionType = {
  Delete: 'Delete',
  Update: 'Update',
  Restore: 'Restore',
  Add: 'Add',
}
